import type React from "react";

import { useState } from "react";
import { Button, Menu, MenuItem, ListItemIcon, ListItemText, Box, Typography, useTheme, alpha } from "@mui/material";
import { KeyboardArrowDown, Check } from "@mui/icons-material";
import { FormattedMessage } from "react-intl";
import { COLORS } from "@/helpers/colors";

const ColorMenu = ({ onColorChange, selectedColorIndex }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleColorSelect = index => {
        onColorChange(index);
        localStorage.setItem("selectedColorIndex", index);
        handleClose();
    };

    const muiTheme = useTheme();
    const open = Boolean(anchorEl);

    const currentTheme = COLORS[selectedColorIndex] || COLORS[0];

    return (
        <>
            <Button
                variant="outlined"
                onClick={handleClick}
                endIcon={<KeyboardArrowDown />}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    borderColor: alpha(muiTheme.palette.primary.main, 0.5),
                    "&:hover": {
                        borderColor: muiTheme.palette.primary.main,
                        boxShadow: `0 2px 8px ${alpha(muiTheme.palette.primary.main, 0.2)}`
                    },
                    transition: "all 0.2s ease-in-out"
                }}
            >
                <Box
                    sx={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        backgroundColor: currentTheme.session,
                        border: `1px solid ${currentTheme.session}`,
                        mr: 1
                    }}
                />
                <Typography variant="body2">
                    <FormattedMessage id="color-theme" />
                </Typography>
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
                slotProps={{
                    paper: {
                        elevation: 3,
                        sx: {
                            mt: 1,
                            minWidth: 200,
                            borderRadius: 2,
                            px: 1
                        }
                    }
                }}
            >
                {COLORS.map((colorSet, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => handleColorSelect(index)}
                        selected={selectedColorIndex === index}
                        sx={{
                            borderRadius: 1,
                            mb: 0.5,
                            "&.Mui-selected": {
                                backgroundColor: alpha(muiTheme.palette.primary.main, 0.1),
                                "&:hover": {
                                    backgroundColor: alpha(muiTheme.palette.primary.main, 0.2)
                                }
                            }
                        }}
                    >
                        <ListItemIcon>
                            <Box
                                sx={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: "50%",
                                    backgroundColor: colorSet.session,
                                    border: `1px solid ${colorSet.session}`
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText primary={colorSet.name} />
                        {selectedColorIndex === index && <Check fontSize="small" color="primary" />}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default ColorMenu;
